// Keep confirmation previews bounded and render all supplied values as plain text.
export function confirmRecordLabel(record, locale) {
  let name = record?.name || record?.code || record?.str_id;
  if (name && typeof name === 'object') name = name[locale] || Object.values(name).find(Boolean);
  return [record?.id != null ? `#${record.id}` : '', name].filter(Boolean).join(' — ');
}

export function confirmList(vm, title, items) {
  return { type: 'section', groups: [{ title, count: items.length, items: items.slice(0, 10),
    more: items.length > 10 ? vm.$t('confirm_details.more_items', { count: items.length - 10 }) : '' }] };
}

export function confirmBlockers(vm, reason) {
  const items = [...new Set(reason.split('\n').map(line => line.trim()).filter(Boolean))];
  return items.length > 1 ? [confirmList(vm, vm.$t('confirm_details.blocking_reasons'), items)] : undefined;
}

export function confirmContentMessage(content) {
  return content.map(block => [block.title, block.text, ...(block.groups || []).map(group =>
    [`${group.title}: ${group.count}`, ...(group.items || []).map(item => `• ${item}`), group.more].filter(Boolean).join('\n'))]
    .filter(Boolean).join('\n')).join('\n\n');
}
